import { MOKA_ESTIMATED_RANK_ADVANTAGE_RANGE_KYU, MOKA_ESTIMATED_RANK_BEST_KYU, MOKA_ESTIMATED_RANK_MINIMUM_HUMAN_MOVE_COUNT, MOKA_ESTIMATED_RANK_WORST_KYU, MOKA_MATCH_EVEN_WIN_PROBABILITY } from "@/constants";
const getMokaEstimatedRank = (averageHumanMovePolicyPercentile, blackWinProbability, humanMoveCount) => {
  if (humanMoveCount < MOKA_ESTIMATED_RANK_MINIMUM_HUMAN_MOVE_COUNT) {
    return null;
  }
  const policyEstimatedKyu = MOKA_ESTIMATED_RANK_WORST_KYU - averageHumanMovePolicyPercentile * (MOKA_ESTIMATED_RANK_WORST_KYU - MOKA_ESTIMATED_RANK_BEST_KYU);
  const normalizedAdvantage = (blackWinProbability - MOKA_MATCH_EVEN_WIN_PROBABILITY) / MOKA_MATCH_EVEN_WIN_PROBABILITY;
  const estimatedKyu = Math.round(Math.min(MOKA_ESTIMATED_RANK_WORST_KYU, Math.max(MOKA_ESTIMATED_RANK_BEST_KYU, policyEstimatedKyu - normalizedAdvantage * MOKA_ESTIMATED_RANK_ADVANTAGE_RANGE_KYU)));
  return `${estimatedKyu} kyu`;
};
export { getMokaEstimatedRank };